import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const mapboxApi = createApi( {
  reducerPath : 'mapboxApi',
  baseQuery : fetchBaseQuery( {
    baseUrl : 'https://api.mapbox.com/geocoding/v5/',
  } ),
  endpoints : ( builder ) => ( {
    getPlacesByName : builder.query( {
      query : ( q ) => `mapbox.places/${q}.json?country=US&access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`,
    } ),
  } ),
} )

export const { useGetPlacesByNameQuery } = mapboxApi
